import { render, staticRenderFns } from "./p1s1c2c3FinishConversation.vue?vue&type=template&id=72461bcd"
import script from "./p1s1c2c3FinishConversation.vue?vue&type=script&lang=js"
export * from "./p1s1c2c3FinishConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports